angular.module('bmsApp.settings')
	.controller('SatisfactionNoteFormCtrl', function (
		$scope,
		notify,
		$timeout,
		SatisfactionNoteSvc
	) {
		var form = {
			validatorConfig: {
				submitHandler: function () {
					$timeout(function () {
						form.processing = true;
						self.errors = null;
						SatisfactionNoteSvc.save({satisfaction_note: self.satisfaction_note}).then(function(response) {
							notify({
								message: 'Customer satisfaction note text saved'
							});
						}, function(error) {
							self.errors = error;
						})
							.finally(function () {
								form.processing = false;
							});
					});
				}
			},
			validatorApi: {},
			settingsData: {},
			processing: false
		};

		var self = {
			methods: {
				init: function () {
					SatisfactionNoteSvc.read()
						.then(function (response) {
							self.loading = false;
							self.satisfaction_note = response.data.satisfaction_note;
						}, function (errors) {
							self.errors = errors;
						})
						.finally(function () {
							self.loading = false;
						});
				}
			},
			form: form,
			loading: true,
			errors: null
		};

		$scope.SatisfactionNoteSvc = self;

	});
